// src/routes/PageDetails.jsx
import { useParams } from "react-router-dom";

import PageRenderer from "./PageRender";
import MenuService from "../../services/MenuService";
import { useQuery } from "@tanstack/react-query";
import Cover404 from "../../common/Cover404";
import { Loader } from "lucide-react";

const PageDetails = () => {
  const { slug } = useParams();
  console.log("🚀 ~ PageDetails ~ slug:", slug)

  const { isLoading, error, data } = useQuery({
    queryKey: ["menu-list"],
    queryFn: MenuService.getList,
  });

  if (isLoading) {
    return <Loader style={{ height: "100vh", color: "#fff" }} />
  }
  if (error) return <div>Error loading page</div>;

  // ✅ FIND PAGE BY SLUG
  const page = data?.find((item) => item.slug === slug);

  if (!page) return <Cover404 />;

  return <PageRenderer pageData={page} />;
};

export default PageDetails;